import { useEffect, useMemo, useRef } from 'react';
import { useRouterWarningContext } from './RouterWarningModalContext';

type Options = {
  id?: string;
  title?: string;
  message?: string;
};

/**
 * Call this hook in any component that has “dirty” state.
 * Pass `when` = true when there are unsaved changes.
 */
export function useUnsavedChangesGuard(when: boolean, options?: Options) {
  const { setGuard, removeGuard } = useRouterWarningContext();

  const idRef = useRef<string>(null);
  if (!idRef.current) {
    idRef.current = `guard:${options?.id ?? Math.random().toString(36).slice(2)}`;
  }
  const id = idRef.current;

  const payload = useMemo(
    () => ({ when, title: options?.title, message: options?.message, id: options?.id }),
    [when, options?.title, options?.message, options?.id],
  );

  useEffect(() => {
    setGuard(id, payload);
    return () => removeGuard(id);
  }, [id, payload, setGuard, removeGuard]);
}
